export default __webpack_public_path__ + "static/media/icon-plus.b6eb7208.webp";